export default "__VITE_ASSET__DXuRDnrc__"